import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import './CardRowLink.css';

const propTypes = {
  to: PropTypes.string,
  type: PropTypes.oneOf([
    'default',
    'secondary',
    'destructive',
  ]),
  onClick: PropTypes.func,
};

const defaultProps = {
  to: '',
  type: 'default',
  onClick: () => {},
};

class CardRowLink extends PureComponent {

  get anchorNode() {
    const {
      children,
      onClick,
      to,
      type,
    } = this.props;

    return (
      <a
        className={`CardRowLink CardRowLink--${type}`}
        href={to}
        rel="noopener noreferrer"
        target="_blank"
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  get linkNode() {
    const {
      type,
      to,
      onClick,
      children,
    } = this.props;

    return (
      <Link
        className={`CardRowLink CardRowLink--${type}`}
        to={to}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  get genericNode() {
    const {
      type,
      onClick,
      children,
    } = this.props;

    return (
      <div
        className={`CardRowLink CardRowLink--${type}`}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }

  render() {
    if (this.props.to) {
      if (this.props.to[0] === '/') {
        return this.linkNode;
      } else {
        return this.anchorNode;
      }
    } else {
      return this.genericNode;
    }
  }
}

CardRowLink.propTypes = propTypes;
CardRowLink.defaultProps = defaultProps;

export default CardRowLink;
